<section id="navegacao">
    <div class="container">
        <div class="row d-flex justify-content-between align-items-center mt-4">
            <div class="col-lg-6 mb-4">
                <h3>{{ data.TITULO }}</h3>
                <button class="btn btn-lg mt-4 p-4" [routerLink]="[ data.BOTAO.URL | localize ]">{{ data.BOTAO.TEXTO }}</button>
            </div>
            <div class="col-lg-5 offset-lg-1 mb-4">
                <p>{{ data.TITULO_MENU }}</p>
                <div class="row d-flex justify-content-between align-items-center">
                    <div class="col-lg-6 p-0" *ngFor="let menu of data.MENUS">
                        <a class="btn btn-link text-left text-white" [routerLink]="[ menu.URL | localize ]"><i class="fas fa-chevron-circle-right icone mr-2"></i> {{ menu.TEXTO }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>